import { Navigate } from 'react-router-dom';
import { isTvMode } from '@lib/runtime';

/**
 * Gate for routes that don't make sense on Android TV / Fire TV / Shield.
 *
 * The in-SPA player + channel grid + favorites / history are a desktop /
 * mobile fallback. On TV form-factors we want the user to install a
 * proper IPTV app (Tivimate, Smarters, OTT Navigator) and use the SPA
 * as a management surface only — set up devices, mint credentials,
 * configure proxy nodes, etc. So when the runtime flags TV mode, these
 * routes redirect home instead of rendering.
 *
 * Web + mobile browsers + Capacitor APK on a phone still get the
 * unrestricted player; the redirect only kicks in for actual TV UAs
 * (Shield, AFT*, BRAVIA) or `?tv=1` override.
 */
export default function TvHiddenRoute({ children }: { children: React.ReactNode }) {
  if (isTvMode()) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
